import serverVars from 'server-vars';
import { sessionStorage } from 'dibs-browser-storage';
import { getAbTestV2, trackAbTestV2Variant } from 'dibs-buyer-layout/exports/clientABTestV2';

const DWELLED_ON_PDP_KEY = 'dwelledOnPdp' as const;
const DWELLED_ON_PDP_AB_TEST_NAME = 'dwelledOnPdpV2' as const;
const DWELL_ON_PDP_LIMIT = 14000;
const DWELL_ON_PDP_LIMIT_DESKTOP = 22000;
const DWELL_ON_PDP_LIMIT_MOBILE = 19000;

const isDwelledOnPdpVariant = (): boolean =>
    getAbTestV2(DWELLED_ON_PDP_AB_TEST_NAME)?.variant === 'variant';

export const getDwelledOnPdp = (): boolean => !!sessionStorage.getItem(DWELLED_ON_PDP_KEY);

export const setDwelledOnPdp = (): NodeJS.Timeout | undefined => {
    trackAbTestV2Variant(DWELLED_ON_PDP_AB_TEST_NAME);
    if (!getDwelledOnPdp()) {
        let dwellTimeLimit = DWELL_ON_PDP_LIMIT;
        if (isDwelledOnPdpVariant()) {
            const isMobile = serverVars.get('settings.isMobile');
            dwellTimeLimit = isMobile ? DWELL_ON_PDP_LIMIT_MOBILE : DWELL_ON_PDP_LIMIT_DESKTOP;
        }

        return setTimeout(() => {
            sessionStorage.setItem(DWELLED_ON_PDP_KEY, true);
        }, dwellTimeLimit);
    }
    return undefined;
};
